import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface SidebarSectionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const SidebarSection: React.FC<SidebarSectionProps> = ({ title, isOpen, onToggle, children }) => (
  <div className="eg-sidebar-section">
    <button onClick={onToggle} className="eg-sidebar-section-header">
      <div className="flex items-center gap-3">
        {isOpen ? (
          <ChevronDown className="w-4 h-4 text-engramiq-green flex-shrink-0" />
        ) : (
          <ChevronRight className="w-4 h-4 text-engramiq-green flex-shrink-0" />
        )}
        <h3 className="text-xs font-semibold eg-text-primary uppercase tracking-wider">{title}</h3>
      </div>
    </button>
    {isOpen && children}
  </div>
);

export default SidebarSection;
